import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=7c044c8b&scoped=true"
var script = {}
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=7c044c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c044c8b",
  null
  
)

export default component.exports